export const INVENTORY_ENDPOINT = `https://${process.env.NEXT_PUBLIC_INVENTORY_GATEWAY_DOMAIN_NAME}`;
